export default __webpack_public_path__ + "static/media/thunder.d09e8f46.svg";